import { useEffect, useState } from "react"
import { useOutletContext } from "react-router-dom"

import { useAppContext } from "@components/AppContext"

import { readOperation } from "./useProjectInvestmentsStore"


const useInvestmentStore = () => {
  const { request } = useAppContext()
  const [ investment, setInvestment ] = useState()

  const readStoreInvestment = id =>
    request(readOperation.id, { id })
      .then(({ data }) => setInvestment(data))

  const useStoreInvestment = id => {
    useEffect(() => {
      if (!id) { return }

      readInvestment(id)
    }, [ id ])

    return investment
  }

  const {
    useInvestment = useStoreInvestment,
    readInvestment = readStoreInvestment,
    updateInvestment = setInvestment
  } = useOutletContext()

  return {
    useInvestment,
    readInvestment,
    updateInvestment,
  }
}

export default useInvestmentStore
